__turbopack_context__.v({
  "badge": "ParagraphPricingTiers-module__-JKqQa__badge",
  "card": "ParagraphPricingTiers-module__-JKqQa__card",
  "cardBody": "ParagraphPricingTiers-module__-JKqQa__cardBody",
  "cardFeatured": "ParagraphPricingTiers-module__-JKqQa__cardFeatured",
  "cardTitle": "ParagraphPricingTiers-module__-JKqQa__cardTitle",
  "check": "ParagraphPricingTiers-module__-JKqQa__check",
  "cta": "ParagraphPricingTiers-module__-JKqQa__cta",
  "eyebrow": "ParagraphPricingTiers-module__-JKqQa__eyebrow",
  "feature": "ParagraphPricingTiers-module__-JKqQa__feature",
  "features": "ParagraphPricingTiers-module__-JKqQa__features",
  "footnote": "ParagraphPricingTiers-module__-JKqQa__footnote",
  "grid": "ParagraphPricingTiers-module__-JKqQa__grid",
  "header": "ParagraphPricingTiers-module__-JKqQa__header",
  "lead": "ParagraphPricingTiers-module__-JKqQa__lead",
  "price": "ParagraphPricingTiers-module__-JKqQa__price",
  "priceRow": "ParagraphPricingTiers-module__-JKqQa__priceRow",
  "priceSecondary": "ParagraphPricingTiers-module__-JKqQa__priceSecondary",
  "priceSuffix": "ParagraphPricingTiers-module__-JKqQa__priceSuffix",
  "section": "ParagraphPricingTiers-module__-JKqQa__section",
  "sectionEyebrow": "ParagraphPricingTiers-module__-JKqQa__sectionEyebrow",
  "subtitle": "ParagraphPricingTiers-module__-JKqQa__subtitle",
  "tagline": "ParagraphPricingTiers-module__-JKqQa__tagline",
  "title": "ParagraphPricingTiers-module__-JKqQa__title",
});
